import { render, staticRenderFns } from "./DegreeToggle.vue?vue&type=template&id=4327e8bf&scoped=true"
import script from "./DegreeToggle.vue?vue&type=script&lang=js"
export * from "./DegreeToggle.vue?vue&type=script&lang=js"
import style0 from "./DegreeToggle.vue?vue&type=style&index=0&id=4327e8bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4327e8bf",
  null
  
)

export default component.exports